<template>
    <div class="report-menu">
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.Sites)"
            :class="{ active: currentTab === ReportTabs.Sites }"
        >
            <p class="label">
                <i class="material-icons">language</i>
                Müşteriler
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.AgentCount)"
            :class="{ active: currentTab === ReportTabs.AgentCount }"
        >
            <p class="label">
                <i class="material-icons">people</i>
                Temsilci Sayısı
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.Payments)"
            :class="{ active: currentTab === ReportTabs.Payments }"
        >
            <p class="label">
                <i class="material-icons">payments</i>
                Ödemeler
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.CustomerCandidate)"
            :class="{ active: currentTab === ReportTabs.CustomerCandidate }"
        >
            <p class="label">
                <i class="material-icons">insights</i>
                Müşteri Aday Analizi
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.Plan)"
            :class="{ active: currentTab === ReportTabs.Plan }"
        >
            <p class="label">
                <i class="material-icons">filter_none</i>
                Planlar
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
        <div
            class="box yes-hover"
            @click="updateQueryParams('report', ReportTabs.Balance)"
            :class="{ active: currentTab === ReportTabs.Balance }"
        >
            <p class="label">
                <i class="material-icons">account_balance_wallet</i>
                Cüzdan
            </p>
            <p class="value">
                <BarSpinner className="spinner" :radius="15" v-if="loading" />
            </p>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import SnakeSpinner from "./SnakeSpinner.vue";
import BarSpinner from "./BarSpinner.vue";
import ReportTabs from "./ReportTabs";
import WhatsappBusinessIcon from "../../Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import { mapState } from "vuex";
import moment from "moment/moment";

export default Vue.extend({
    name: "ReportMenu",
    computed: {
        ReportTabs() {
            return ReportTabs;
        },
        ...mapState({
            user: (state) => state.auth.user,
            adminUser: (state) => state.auth.adminUser,
        }),
    },
    components: { WhatsappBusinessIcon, SnakeSpinner, BarSpinner },
    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        updateQueryParams: {
            type: Function,
            default: () => {},
        },
        currentTab: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            loadingBars: null,
        };
    },
    mounted() {
        console.log("mounted user", this.user);
        console.log("mounted adminUser", this.adminUser);
        this.loadingBars = Array.from(document.querySelectorAll(".box > .value")).map((el) => {
            return this.$veLoading({
                target: document.querySelector(".box > .value"),
                name: "wave",
            });
        });
        if (this.loading) {
            // this.loadingBars.forEach((bar) => bar.show());
        }
    },
    watch: {
        loading(newVal) {
            if (newVal) {
                // this.loadingBars.forEach((bar) => bar.show());
            } else {
                // this.loadingBars.forEach((bar) => bar.close());
            }
        },
    },
});
</script>

<style scoped lang="scss">
$box-colors: [ "#800080", "#FF8C00", "#8B4513", "#663399", "#FF0000", "#00FF00", "#0000FF", "#4B0082", "#8B0000",
    "#FFC0CB", "#008080", "#FFA500" ];

.report-menu {
    position: sticky;
    top: 0;

    .box.no-shadow {
        box-shadow: none;
        cursor: auto;

        &:hover {
            box-shadow: none;
        }
    }

    .box.yes-hover {
        cursor: pointer;

        &:hover {
            background-color: #fff4de;
        }
    }

    .box {
        width: 300px;
        max-width: 300px;
        height: 36px;
        border-radius: 6px;
        display: flex;
        background-color: #ffffff;
        padding: 8px;
        align-items: center;
        margin-bottom: 8px;
        /* box-shadow: 0 0 3px #1E1E2D;*/
        cursor: pointer;
        transition: all 0.3s;

        .label {
            display: flex;
            gap: 5px;
            align-items: center;
            font-size: 14px;
            font-weight: 600;
            color: #181c32;
        }

        &.active {
            background-color: #fff4de;
            box-shadow: 0 0 6px #00000080;
        }

        .value {
            svg {
                width: 30px;
                height: 30px;
            }
        }

        &:hover {
            box-shadow: 0 0 6px #00000080;
        }

        &:last-child {
            margin-bottom: 0;
        }

        p {
            margin: 0;
            font-size: 12px;
            font-weight: 300;
            font-family: Poppins;
            color: #181c32;
            white-space: nowrap;
        }

        p + p {
            font-weight: 700;
            margin-left: auto;
        }
    }

    //&::before {
    //    content: "";
    //    display: block;
    //    min-width: 20px;
    //    height: 20px;
    //    border-radius: 3px;
    //    margin-right: 8px;
    //}

    @for $i from 0 through 10 {
        .box:nth-child(#{$i}) {
            .material-icons {
                color: unquote(nth($box-colors, $i + 1));
            }
        }
    }
}
</style>
